import gql from "graphql-tag";

export const LoginErrorOrResultFragment = gql`
  fragment LoginErrorOrResultFragment on LoginResultOrError {
    __typename
    ... on LoginError {
      error
    }
    ... on LoginResult {
      isNewUser
      authentication {
        sessionToken
      }
    }
  }
`;
